import DisplayListFunctionalComponentV2CustomModel from "../componentsV2/DsiplayTravelerListV2";
// import React, {useEffect, useState} from "react";
// import {useEffect} from "react";
import {useNavigate} from "react-router-dom";



import React, {Component, useState} from "react";
// import ToDoList from "./ToDoList"
/* Class Contact uses for display and read a data from database, data is imported from other classes */
//props are data inside the divs
import '../components/FormCreateListV2CustomModel.css';
// import 'materialize-css';
import DisplayCustomerTrip from "../components/DisplayCustomerTrip";
import {useEffect} from "react";
import DisplayStateOfCustomerList from "../components/DisplayStateOfCustomerList";
// import {UserContext} from "../UserContext";
import '../components/DisplayListComponent.css';
// import {useNavigate} from "react-router-dom";


// Author: Mrek Augustyn
// Date: 27 April 2026
// Description: I am working on the new version of Display Traveler List, using lee components then previous version.
// Not finished yet


const  DisplayTravelerListV2CustomModel= () => {


    const navigate = useNavigate();


    const [tripData, setTripData] = useState([]);
// const [response, setResponse] = useState([]);
    let [displayTripDetail, setDisplayTripDetail] = useState(false);
    const [displayTripDetail2, setDisplayTripDetail2] = useState(false);
    const [displayTripDetail3, setDisplayTripDetail3] = useState(false);
    const [displayTripDetail4, setDisplayTripDetail4] = useState(false);
    const [loggedCustomerId] = useState(1);
    const [tripId, setTripId] = useState("");

    const STATUS = document.getElementById('status');
    const [tripWasLoaded, setTripWasLoaded] = useState(false);

//Fetch data from Heroku Old Backend before JWT
// useEffect(() => {
//     //do something when loading
//     // console.log("signal to do something using useEffect")
//     fetch("https://smartluggagebackend.herokuapp.com/api/v1/trip").then((response) => response.json()).then((TripData) => {
//         // fetch("api/v1/trip/").then((response) => response.json()).then((TripData) => {
//         // console.log("List of items in the trip", TripData);
//         setTripData(TripData);
//         // calculateLastTripId();
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
// }, ["hI trip"]);

    /**
     * Loads the MobileNet model and warms it up so ready for use.
     **/
        // async function loadMobileNetFeatureModel() {
        //     const URL = 'https://tfhub.dev/google/tfjs-model/imagenet/mobilenet_v3_small_100_224/feature_vector/5/default/1';
        //     // mobilenet = await tf.loadGraphModel(URL, {fromTFHub: true});
        //     STATUS.innerText = 'MobileNet v3 loaded successfully!';
        //
        //     // Warm up the model by passing zeros through it once.
        //     tf.tidy(function () {
        //         let answer = mobilenet.predict(tf.zeros([1, MOBILE_NET_INPUT_HEIGHT, MOBILE_NET_INPUT_WIDTH, 3]));
        //         console.log(answer.shape);
        //     });
        // }

        // loadMobileNetFeatureModel();

        // Variable and function refresh
    const [pageWasRefreshed, setPageWasRefreshed] = useState(false);

    function refresh(){

        if(pageWasRefreshed === true){
            window.location.reload();
        }
        else if(pageWasRefreshed === true){
            console.log("Page was refreshed already")
        }

    }





//Fetch data from database
    useEffect(() => {
            //do something when loading
            // console.log("signal to do something using useEffect")
            fetch("https://mareka.alwaysdata.net/api/v1/trip").then(
                (response) => {
                    // console.log(response.json())
                    console.log("display response after post");
                    console.log(response);
                    if (!response.ok) {
                        console.log("Waiting for data from the backend");
                        // alert("Wait a second and refresh the page");
                        STATUS.innerText = 'Something went wrong try refresh website';
                        setTripWasLoaded(false);
                        navigate("/displayListCustomModel");
                    } else {
                        console.log("All good when tried display")
                        // STATUS.innerText = 'Trip data is loaded.';
                        setTripWasLoaded(true);
                        //save fetched data to the memory in the tripData array
                        response.json().then((TripData)=> {
                            setTripData(TripData);
                        });
                        // navigate("/createOrDisplayList");
                    }
                }
            )
            // .
            // then((TripData) => {
            // fetch("api/v1/trip/").then((response) => response.json()).then((TripData) => {
            // console.log("List of items in the trip", TripData);
            // setTripData(TripData);
            // calculateLastTripId();
            // });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        , [STATUS, navigate]);//check if this is not a problem ??????






    return (

        <div id={"DisplayListFirstPage"}>
            <div className="container-fluid">

                <div className="container">
                    <div className="row">
                        <div className="col s2"></div>
                        <div className="col s8">
                            <p id="PageTitle"> YOUR LUGGAGE <span style={{color:'white',fontSize:'0.5em'}} > CM </span> </p>
                        </div>
                        <div className="col s2"></div>
                    </div>
                </div>
                {/*<div className="row">*/}
                {/*    <DisplayListFunctionalComponentV2CustomModel/>*/}
                {/*</div>*/}

                <div id="positionDisplayStateOfCustomerList">

                    {tripWasLoaded ? <DisplayStateOfCustomerList/>:    <p id="status"> Awaiting for load data from the backend. </p>

                    }
                </div>
            </div>
        </div>



    );
}

export default DisplayTravelerListV2CustomModel ;